import PageLayout from "@/pages/home/components/PageLayout";
import ReviewsSection from "@/pages/home/components/ReviewsSection";

export default function ReviewsPage() {
  return (
    <PageLayout>
      <ReviewsSection />
    </PageLayout>
  );
}
